import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";

const boxWidth = 14.8
const boxHeight = 20
const gap = 6
const boxWithGap = boxWidth + gap
const centerBoxX = 50 - (boxWidth / 2)
const rects = [
    {
        opacityRange: [0, 2, 2.01, 3], opacityOutput: [0, 0, 1, 1],
        heightRange: [0, 2, 2.01, 2.4, 3], heightOutput: [0, 0, (boxHeight * 0.1), boxHeight, boxHeight],
        translateYRange: [0, 2, 2.4, 3], translateYOutput: [-10, -10, 0, 0],
    },
    {
        opacityRange: [0, 2, 2.01, 2.03, 3], opacityOutput: [0, 0, 0, 1, 1],
        heightRange: [0, 2, 2.01, 2.03, 2.45, 3], heightOutput: [0, 0, 0, (boxHeight * 0.1), boxHeight, boxHeight],
        translateYRange: [0, 2, 2.01, 2.45, 3], translateYOutput: [-10, -10, -10, 0, 0],
    },
    {
        opacityRange: [0, 2, 2.02, 2.07, 3], opacityOutput: [0, 0, 0, 1, 1],
        heightRange: [0, 2, 2.02, 2.07, 2.5, 3], heightOutput: [0, 0, 0, (boxHeight * 0.1), boxHeight, boxHeight],
        translateYRange: [0, 2, 2.02, 2.5, 3], translateYOutput: [-10, -10, -10, 0, 0],
    },
    // 중앙
    {
        opacityRange: [0, 2, 2.05, 2.13, 3], opacityOutput: [0, 0, 0, 1, 1],
        heightRange: [0, 2, 2.05, 2.13, 2.55, 3], heightOutput: [0, 0, 0, (boxHeight * 0.1), boxHeight, boxHeight],
        translateYRange: [0, 2, 2.05, 2.55, 3], translateYOutput: [-10, -10, -10, 0, 0],
        translateXRange: [0, 2.85, 3], translateXOutput: [0, 0, -7],
        scaleXRange: [0, 2.85, 3], scaleXOutput: [1, 1, 1.9],
    },
    {
        opacityRange: [0, 2, 2.1, 2.19, 3], opacityOutput: [0, 0, 0, 1, 1],
        heightRange: [0, 2, 2.1, 2.19, 2.6, 3], heightOutput: [0, 0, 0, (boxHeight * 0.1), boxHeight, boxHeight],
        translateYRange: [0, 2, 2.1, 2.6, 3], translateYOutput: [-10, -10, -10, 0, 0],
    },
    {
        opacityRange: [0, 2, 2.2, 2.3, 3], opacityOutput: [0, 0, 0, 1, 1],
        heightRange: [0, 2, 2.2, 2.3, 2.65, 3], heightOutput: [0, 0, 0, (boxHeight * 0.1), boxHeight, boxHeight],
        translateYRange: [0, 2, 2.2, 2.65, 3], translateYOutput: [-10, -10, -10, 0, 0],
    },
    {
        opacityRange: [0, 2, 2.22, 2.4, 3], opacityOutput: [0, 0, 0, 1, 1],
        heightRange: [0, 2, 2.22, 2.4, 2.7, 3], heightOutput: [0, 0, 0, (boxHeight * 0.1), boxHeight, boxHeight],
        translateYRange: [0, 2, 2.22, 2.7, 3], translateYOutput: [-10, -10, -10, 0, 0],
    },
]

export const Section11 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={`${styles['animation-container']} ${styles['white-like-background']}`} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec11}`}>
                <animated.p className={`${styles.sec11__font01} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 0.3, 2.5, 2.6],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.3, 1, 2.4, 2.6],
                        output: [10, 10, 0, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>새로워진 앱에서</animated.p>
                <animated.p className={`${styles.sec11__font02} ${styles.notoBold} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 0.3, 2.5, 2.6],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.3, 1, 2.4, 2.6],
                        output: [10, 10, 0, 0, 0, -10]
                    }).to(x => `${x}vh`),
                    WebkitTextFillColor: spring.x.to({
                        range: [0.8, 1.5, 2],
                        output: [0, 1, 1]
                    }).to(x => `rgba(0, 0, 0, ${x})`)
                }}>거래는 더 빨리<br></br>이동은 더 쉽게</animated.p>
            </div>
            <animated.svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"
                          className={styles['section11-rotation']}
                          style={{
                              rotate: spring.x.to({
                                  range: [0, 2.4, 2.6, 2.7, 2.8, 3],
                                  output: [0, 0, 12.5, 28.7, 45, 90]
                              }).to(x => `${x}deg`),
                              scaleY: spring.x.to({
                                  range: [0, 2.4, 2.6, 2.7, 2.99, 3],
                                  output: [1, 1, 2, 4.5, 11, 11]
                              }).to(x => x),
                              scaleX: spring.x.to({
                                  range: [0, 2.4, 2.6, 3],
                                  output: [1, 1, 1.7, 8]
                              }).to(x => x),
                          }}
            >
                { rects.map((rect, index) => <animated.rect
                    key={index}
                    className={styles['section11-transition__item']}
                    style={{
                        // width: `${boxWidth}vw`,
                        x: `${centerBoxX + ((index - 3) * boxWithGap)}vw`,
                        opacity: spring.x.to({
                            range: rect.opacityRange,
                            output: rect.opacityOutput,
                        }).to(x => x),
                        height: spring.x.to({
                            range: rect.heightRange,
                            output: rect.heightOutput
                        }).to(x => `${x}vw`),
                        translateY: spring.x.to({
                            range: rect.translateYRange,
                            output: rect.translateYOutput
                        }).to(x => `${x}vw`),
                        fillOpacity: spring.x.to({
                            range: [0, 2.4, 2.6, 3],
                            output: [0, 0, 1, 3]
                        }).to(x => x),
                        translateX: spring.x.to({
                            range: rect.translateXRange ?? [0, 3],
                            output: rect.translateXOutput ?? [0, 0]
                        }).to(x => `${x}vw`),
                        scaleX: spring.x.to({
                            range: rect.scaleXRange ?? [0, 3],
                            output: rect.scaleXOutput ?? [1, 1]
                        }).to(x => x),
                    }}
                />)}
            </animated.svg>
        </animated.div>
    )
}